/* eslint-disable no-console */

import { register } from 'register-service-worker';
import { messageSW } from 'workbox-window';
import Notification from 'element-ui/lib/notification';

let isRefreshing = false;
let isManualRefreshing = false;
let isUpdateNotification = false;
let timeout;

function updateTimer (sw) {
    timeout = setTimeout(() => {
        isManualRefreshing = true;
        clearTimeout(timeout);
        sw.update();
        updateTimer(sw);
    }, 120 * 1000);
}

function invokeServiceWorkerUpdateFlow (sw) {
    !isUpdateNotification && messageSW(sw.waiting, { type: 'GET_CLIENTS_COUNT' })
        .then(({ clients }) => {
            isUpdateNotification = true;
            if ((!clients || clients === 1) && !isManualRefreshing) {
                messageSW(sw.waiting, { type: 'SKIP_WAITING' });
                return true;
            }
        })
        .then((result) => {
            if (!result) {
                Notification({
                    message: 'New App version is available. Click here to refresh',
                    duration: 0,
                    type: 'info',
                    onClick: () => messageSW(sw.waiting, { type: 'SKIP_WAITING' }),
                });
            }
        });
}


if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready (sw) {
            console.log('App is being served from cache by a service worker.');

            navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (!isRefreshing) { // prevent infinite refresh loop when you use "Update on Reload" in DevTools
                    isRefreshing = true;
                    messageSW(sw.active, { type: 'GET_CLIENTS_COUNT' })
                        .then(({ clients }) => {
                            if ((clients && clients > 1) || isManualRefreshing) {
                                window.location.reload();
                            }
                        });
                }
            });

            if (sw.waiting) {
                invokeServiceWorkerUpdateFlow(sw);
            }

            updateTimer(sw);
        },
        registered () {
            console.log('Service worker has been registered.');
        },
        cached () {
            console.log('Content has been cached for offline use.');
        },
        updatefound () {
            console.log('New content is downloading.');
        },
        updated (sw) {
            console.log('New content is available; please refresh.');

            invokeServiceWorkerUpdateFlow(sw);
        },
        offline () {
            console.log('No internet connection found. App is running in offline mode.');
        },
        error (error) {
            console.error('Error during service worker registration:', error);
        },
    });
}
